import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as turf from '@turf/turf';
import { TaggingProvider } from '../../providers/posts/tagging.provider';
import { NavController } from 'ionic-angular';

/**
 * Generated class for the TripImageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'tagging-users',
  templateUrl: 'tagging-users.html',
})
export class TaggingUsersComponent {
  log = debug('app:TaggingUsersComponent');

  input: Element;
  filteredPeople = [];
  taggedUsers = [];
  @Output() selectedUsers = new EventEmitter();

  constructor(
    public taggingProvider: TaggingProvider,
    public navCtrl: NavController
  ) {
    // this.log('constructed', this.input);
  }

  ngOnInit() {
    try {
      this.log('init', this.input);
      this.setupListeners();
    } catch (e) {}
  }

  ngOnDestroy() {
    this.taggingProvider.reset();
  }

  setupListeners() {
    const contenteditable = document.getElementById('cm-taggable-textarea');
    const isEditable =
      contenteditable.getAttribute('contenteditable') === 'true';
    this.log('setupListeners', contenteditable, isEditable);

    this.input = contenteditable;

    if (!contenteditable || !isEditable) {
      return console.warn('TaggingUsers | no contenteditable found');
    } else {
      this.log('input', this.input);
    }

    this?.input?.addEventListener('input', e => {
      // InputEvent
      // e.inputType === 'insertText'            && e.data === user typed letter
      // e.inputType === 'deleteContentBackward' && e.data === null
      // this.log('input', e);
      this.runTagging(e);
    });
    // this.input.nativeElement.addEventListener('submit', e => {
    //   // this.log('submit', e);
    // });
    // this.input?.addEventListener('value', e => {
    // CustomEvent
    // e.detail.value = input value
    // this.log('value', e);
    // this.runTagging(e)
    // });
    // this.input.nativeElement.addEventListener('blur', e => {
    //   // this.log('blur', e);
    // });
  }

  runTagging = _.debounce(e => {
    this.log('runTagging', e, this.input);
    this.taggingProvider
      .start(e, this.input)
      .then(() => this.getFilteredPeople());
  }, 250);

  getFilteredPeople() {
    this.filteredPeople = this.taggingProvider.searchResults.people.filter(
      person =>
        !this.taggedUsers.some(taggedPerson => taggedPerson._id === person._id)
    );
  }

  selectUser(u) {
    // setTimeout(() => {
    //   this.input.querySelectorAll(`.cdlc-user-anchor`).forEach(anchor => {
    //     anchor.addEventListener('click', () => {
    //       this.navCtrl.push('UserProfilePage', {
    //         user_id: _.replace(anchor.id, 'userId-', ''),
    //       });
    //     });
    //   });
    // }, 250);
    return this.taggingProvider.selectUser(u);
  }
}



// WEBPACK FOOTER //
// ./src/components/tagging-users/tagging-users.ts